module.exports = __webpack_public_path__ + "static/media/Path 36741.640401e4.svg";